import { z } from "zod";

// ─── UnitTypes ───────────────────────────────────────────────────────────────
export const unitTypeIdSchema = z.string().uuid("ID de tipo de unidad inválido");

export const createUnitTypeSchema = z.object({
  code: z.string().min(1, "El código es requerido").max(10).toUpperCase(),
  name: z.string().min(1, "El nombre es requerido").max(200),
});

export const updateUnitTypeSchema = createUnitTypeSchema.partial();

export const unitTypeQuerySchema = z.object({
  deleted: z.enum(["true", "false"]).optional(),
});

// ─── Exports ─────────────────────────────────────────────────────────────────
export type UnitTypeId = z.infer<typeof unitTypeIdSchema>;
export type CreateUnitType = z.infer<typeof createUnitTypeSchema>;
export type UpdateUnitType = z.infer<typeof updateUnitTypeSchema>;
export type UnitTypeQuery = z.infer<typeof unitTypeQuerySchema>;
